// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1-QGJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__10SpD"};